import { useSubject as useCoreSubject, SubjectHookOutput } from '@ts-core/modules/subjects/hooks';

import { subjectsTreeFragment } from '../graphql/fragments';
import { Subject } from '../types';

interface SubjectHookInput {
  courseId: string;
  subjectId: string;
}

export default function useSubject(input: SubjectHookInput): SubjectHookOutput<Subject> {
  return useCoreSubject({ ...input, subjectsTreeFragment });
}
